import { render, staticRenderFns } from "./BodySignIn.vue?vue&type=template&id=7f637744&scoped=true&"
import script from "./BodySignIn.vue?vue&type=script&lang=js&"
export * from "./BodySignIn.vue?vue&type=script&lang=js&"
import style0 from "./BodySignIn.vue?vue&type=style&index=0&id=7f637744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f637744",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
